import React from 'react';

const iconProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true
};

function IconAll() {
  return (
    <svg {...iconProps}>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  );
}

function IconElectronics() {
  return (
    <svg {...iconProps}>
      <rect x="6" y="2" width="12" height="20" rx="2" />
      <line x1="12" y1="18" x2="12" y2="18" />
    </svg>
  );
}

function IconHome() {
  return (
    <svg {...iconProps}>
      <path d="M4 10.5L12 4l8 6.5V20a1 1 0 01-1 1h-5v-6H10v6H5a1 1 0 01-1-1v-9.5z" />
    </svg>
  );
}

function IconFashion() {
  return (
    <svg {...iconProps}>
      <path d="M12 3l3 4h4l-3 14H8L5 7h4l3-4z" />
    </svg>
  );
}

function IconBeauty() {
  return (
    <svg {...iconProps}>
      <path d="M9 3h6v4a3 3 0 01-6 0V3zM8 21h8M12 10v11" />
    </svg>
  );
}

function IconToys() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="8" />
      <path d="M9 9h.01M15 9h.01M9 15s1.5 2 3 2 3-2 3-2" />
    </svg>
  );
}

function IconBooks() {
  return (
    <svg {...iconProps}>
      <path d="M5 4h7a2 2 0 012 2v14H7a2 2 0 01-2-2V4zM12 6h7v14h-7" />
    </svg>
  );
}

function IconSports() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v4M12 18v4M2 12h4M18 12h4M4.9 4.9l2.8 2.8M16.3 16.3l2.8 2.8M4.9 19.1l2.8-2.8M16.3 7.7l2.8-2.8" />
    </svg>
  );
}

function IconAuto() {
  return (
    <svg {...iconProps}>
      <path d="M5 16h14l-1.5-5.5a2 2 0 00-1.9-1.5H8.4a2 2 0 00-1.9 1.5L5 16zM7 16v2M17 16v2" />
      <circle cx="8" cy="16" r="1.5" />
      <circle cx="16" cy="16" r="1.5" />
    </svg>
  );
}

function IconDefault() {
  return (
    <svg {...iconProps}>
      <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
    </svg>
  );
}

const ICON_BY_KEY = {
  all: IconAll,
  electronics: IconElectronics,
  home: IconHome,
  fashion: IconFashion,
  beauty: IconBeauty,
  toys: IconToys,
  books: IconBooks,
  sports: IconSports,
  auto: IconAuto,
  default: IconDefault
};

export function resolveCategoryIconKey(category) {
  if (!category || category.id === 'all') return 'all';
  const text = `${category.slug || ''} ${category.name || ''}`.toLowerCase();
  if (/electronic|phone|computer|tech|gaming/.test(text)) return 'electronics';
  if (/home|kitchen|furniture|carpet|rug|decor/.test(text)) return 'home';
  if (/fashion|cloth|apparel|wear/.test(text)) return 'fashion';
  if (/beauty|personal|care|cosmetic/.test(text)) return 'beauty';
  if (/toy|kid|baby/.test(text)) return 'toys';
  if (/book|stationery|office/.test(text)) return 'books';
  if (/sport|outdoor/.test(text)) return 'sports';
  if (/auto|car|motor/.test(text)) return 'auto';
  if (/accessor/.test(text)) return 'fashion';
  if (/store/.test(text)) return 'default';
  return 'default';
}

export function CategoryIcon({ category }) {
  const key = resolveCategoryIconKey(category);
  const Cmp = ICON_BY_KEY[key] || IconDefault;
  return <Cmp />;
}
